import { c as _c } from "react/compiler-runtime";
import { clsx } from "@/helpers/clsx";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import { MegaphoneIcon } from "@heroicons/react/24/solid";
import Link from "next/link";
export type LastUpdateProp = {
  slug: string;
  title: string;
  [key: string]: any;
};
export const LastUpdate = t0 => {
  const $ = _c(14);
  const {
    update,
    className,
    showIcon
  } = t0;
  const t1 = `/updates#${update.slug}`;
  let t2;
  if ($[0] !== className) {
    t2 = clsx("inline-flex select-none items-center gap-x-1 rounded-full border border-neutral-100/10 bg-neutral-900/80 px-5 py-1.5 pr-2 text-[12.5px] font-semibold text-white transition-all hover:bg-neutral-800 active:scale-[0.97]", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== showIcon) {
    t3 = showIcon && <MegaphoneIcon className="-ml-2.5 size-4 opacity-50" />;
    $[2] = showIcon;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== update.title) {
    t4 = <span className="truncate">{update.title}</span>;
    $[4] = update.title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <span className="flex min-w-0 items-center gap-2">{t3}{t4}</span>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronRightIcon className="size-4 opacity-50" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t5) {
    t7 = <Link href={t1} className={t2}>{t5}{t6}</Link>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};